import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

type CheckboxItems = {
  label: string;
  labelAr: string;
  id: string;
};

type Selection = string[] | string | undefined;

@Component({
  selector: 'educare-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  imports: [CommonModule, MatCheckboxModule]
})
export class CheckboxComponent {
  @Input() selected!: Selection;
  @Input() disabled: boolean = false;
  @Input() items!: CheckboxItems[];
  @Input() multiple: boolean = true;
  @Output() selectionChange = new EventEmitter<Selection>();
  Array = Array;

  onChange($event: MatCheckboxChange, id: string) {
    if (this.multiple) {
      if (!this.selected) this.selected = [];
      if ($event.checked) {
        (this.selected as string[]).push(id);
      } else {
        const index = (this.selected as string[]).indexOf(id);
        if (index > -1) (this.selected as string[]).splice(index, 1);
      }
    } else {
      this.selected = $event.checked ? id : undefined;
    }
    this.selectionChange.emit(this.selected);
  }
}
